import { analytics } from '@/services'
import { onboardingContributeStore } from '@/stores'
import { OnboardingModal } from '../OnboardingModal'
import { PromptModal } from '../SelectPromptModal'
import { PostOptionsModal } from '../PostOptions'
import { Chapter, Prompt } from '@/types'

type Params = {
  prompt?: Prompt
  lesson?: Chapter['id']
}

export async function onContributeStart(params: Params = {}) {
  analytics.track('contribute_start')

  if (onboardingContributeStore.shouldShowOnboarding()) {
    if (!await OnboardingModal.request()) return
  }

  let prompt: Prompt | undefined
  if (!params.prompt) prompt = await PromptModal.request()

  PostOptionsModal.open({ prompt, ...params })
}
